// Follow-ups do pipeline privado (05/10/2026) — item do Comercial logo abaixo
// do Pipeline. Pedido do Lucas: "crie uma página no comercial, junto ao
// pipeline privado, para eu configurar follow-ups automáticos".
// Fila (o que pede ação) · Enviados (e-mails e tarefas) · Regras (cadência,
// template, sem resposta) · Limpeza (o estoque que já estava em Follow-up).
// Doc: docs/followups-propostas.md.
//
// O menu (App.tsx) usa a UNIÃO das permissões das abas (docs/menu-hubs.md).
import HubAbas, { HubTab } from '../../components/HubAbas';
import AbaFila from '../comercial-followups/AbaFila';
import AbaEnviados from '../comercial-followups/AbaEnviados';
import AbaRegras from '../comercial-followups/AbaRegras';
import AbaLimpeza from '../comercial-followups/AbaLimpeza';

const TABS: HubTab[] = [
  { key: 'fila',      label: '📞 Fila',      perm: 'comercial.pipeline.ver',          render: () => <AbaFila /> },
  { key: 'enviados',  label: '✉️ Enviados',  perm: 'comercial.pipeline.ver',          render: () => <AbaEnviados /> },
  { key: 'regras',    label: '⚙️ Regras',    perm: 'comercial.pipeline.ver',          render: () => <AbaRegras /> },
  { key: 'limpeza',   label: '🧹 Limpeza',   perm: 'comercial.followups.configurar',  render: () => <AbaLimpeza /> },
];

export default function ComercialFollowupsHub() {
  return <HubAbas tabs={TABS} />;
}
